// extracted by mini-css-extract-plugin
export var modalContent = "CookiesSettingsModal-module--modalContent--0bVCr";
export var modalActions = "CookiesSettingsModal-module--modalActions--5Y4K9";
export var confirmButton = "CookiesSettingsModal-module--confirmButton--GT7Fs";
export var cancelButton = "CookiesSettingsModal-module--cancelButton--4KYnZ";